module.exports = "/assets/5abce96d77466d4edd42029f0ee05738.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/OR.png
// module id = 2814
// module chunks = 0